import React from "react";
import { Button } from "@amzn/awsui-components-react/polaris";
import { statusColorCodes } from '../../../common/utils/commonUtils';

// Dedicated per-task column set for the Transaction Details page.
//
// The Input File cell needs the component-scoped `downloadArtifacts` helper
// (it closes over params.domain / tableDispatcher / setLoading), so the column
// definitions are produced by a factory that receives that helper. The array
// contents and rendering logic are unchanged from the previous inline version.
export const getTransactionDetailColumnDefinitions = (downloadArtifacts) => [
    {
        id: "taskId",
        header: "Task ID",
        cell: record => record.taskId
    },
    {
        id: "taxIdentifier",
        header: "Tax Identifier",
        cell: record => record.taxIdentifier || ""
    },
    {
        id: "status",
        header: "Status",
        cell: record => (<div style={statusColorCodes(record.status)}>{record.status}</div>)
    },
    {
        id: "taskInputFile",
        header: "Input File",
        cell: record => {
            const hasInput = record.inputFileBucket && record.inputFilePath;
            return (
                <Button
                    iconName="download"
                    variant="inline-link"
                    disabled={!hasInput}
                    ariaLabel={hasInput ? undefined : "No file available"}
                    onClick={hasInput ? () => downloadArtifacts(record.inputFilePath, record.inputFileBucket) : undefined}>
                    Download
                </Button>
            );
        },
        minWidth: 150
    },
    {
        // Receipt wiring is out of scope for this change - always show a disabled button, never a blank cell.
        id: "taskSubmissionReceipt",
        header: "Submission Receipt",
        cell: () => (
            <Button
                iconName="download"
                variant="inline-link"
                disabled
                ariaLabel="No file available">
                Download
            </Button>
        ),
        minWidth: 150
    },
    {
        id: "errorDetails",
        header: "Error Details",
        cell: record => record.errorDetails || "",
        minWidth: 400
    }
];

export const transactionDetailVisibleColumns = [
    "taskId",
    "taxIdentifier",
    "status",
    "taskInputFile",
    "taskSubmissionReceipt",
    "errorDetails"
];
